import React from 'react';
import { StockMonitoringList } from './StockMonitoringList';
import { StockTransactionForm } from './StockTransaction/StockTransactionForm';

const stockMonitoringRoutes = [
	{
		props: {
			exact: true,
			path: `/menu/outlet-app/:outletID/stock-monitoring`,
		},
		component: <StockMonitoringList />,
	},
	{
		props: {
			exact: true,
			path: `/menu/outlet-app/:outletID/stock-monitoring/stock-transaction`,
		},
		component: <StockTransactionForm />,
	},
];

export default stockMonitoringRoutes;

